import { Tooltip } from 'antd';
import React from 'react';
import CurrencyIcon from '../../../Common/CurrencyIcon';
import PlatformIconRender from '../../../Common/PlatformIconRender';

const CampaignBaseDetailsComponent = ({ name, companyname, campId, objective, creativesCount, posts, platform, earnings }) => {
  return (
    <div className="row campaign_details_base">
      <div className="col-md-4">
        <p>Campaign Name</p>
        <h6 className="spl">{name || 'n/a'}</h6>
      </div>
      <div className="col-md-3">
        <p>Brand</p>
        <h6>{companyname || 'n/a'}</h6>
      </div>
      <div className="col-md-4">
        <p>Campaign ID</p>
        <h6 >{campId || 'n/a'}</h6>
      </div>
      <div className="col-md-2">
        <p>Objective</p>
        <h6>{objective || 'n/a'}</h6>
      </div>
      <div className="col-md-3">
        <p>Total Creatives</p>
        <h6>{creativesCount || 'n/a'}</h6>
      </div>
      <div className="col-md-2">
        <p>Total Posts</p>
        <h6>{posts || 'n/a'}</h6>
      </div>
      <div className="col-md-2">
        <p>Platform</p>
        <h6><Tooltip title={platform}><PlatformIconRender platform={platform}
          size={20}/></Tooltip></h6>
      </div>
      <div className="col-md-3">
        <p>Approx Earning</p>
        <h6>{CurrencyIcon()} <strong>{earnings.min}</strong> to <strong>{earnings.max}</strong></h6>
      </div>
    </div>
  );
};

export default CampaignBaseDetailsComponent;
